import { render } from "./UpdateEmail.vue?vue&type=template&id=2304a94f&scoped=true"
import script from "./UpdateEmail.vue?vue&type=script&lang=js"
export * from "./UpdateEmail.vue?vue&type=script&lang=js"

import "./UpdateEmail.vue?vue&type=style&index=0&id=2304a94f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2304a94f"]])

export default __exports__